import axios from 'axios';

const baseURL = 'api/Cuestionario/resultado';

async function getResultadoByCuestionario(idCuestionario, usuario) {

    const { data } = await axios.get(baseURL + "?idUsuario=" + usuario.id + "&idCuestionario=" + idCuestionario + "&idioma=" + usuario.language,
    {
        headers: {
            'token': usuario.token
        }
        }
    );

    return data;
}

export default { getResultadoByCuestionario };